// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1ZDDn","title":"Images90_title__3TuqP","images":"Images90_images__53qWh"};